<div class="u-shadow-mini pos-relative">
    <app-loader [showLoader]=showLoad></app-loader>
    <div class="c-portlet_box_specs">
        <div
            class="c-portlet__header o-stack o-stack--center o-stack--splitted u-border-bottom u-px-small u-py-mini c-portlet-gap primary-color-bg">
            <div class="o-stack__cell">
                <h5>Creative: {{sectiontitle}}</h5>
            </div>
        </div>
        <div class="analytics-portlet-content creative-performance-div {{sectionclass}}">
            <div class="creative-performance-area" [ngClass]="{'no-data-height': !hasData}">
                <div *ngIf="!hasData">
                    <img [src]="placeholderimage" class="no-creative-data" />
                </div>
                <div *ngIf="hasData">
                    <ngu-carousel class="creative-performance-stats" #carousel [inputs]="carouselOne"
                        [dataSource]="creatives">
                        <ngu-tile NguCarouselItem *nguCarouselDef="let creativeData; let i = index">
                            <div [ngClass]="{'ht-100-social': creativeData.isSocial, 'ht-100': !creativeData.isSocial}">
                                <div class="carousel-area">
                                    <app-creative-performance-stats-v7 [creative]="creativeData" [creativesNum]="creatives.length" [sectionclass]="sectionclass"
                                        [creativeIndex]="i" [showStats]="true" [metricsArray]="getMetricsArray(creativeData)"
                                        (previewCreativeEvent)="previewCreative($event)"
                                        [sectiontitle]="sectiontitle" (navigationBackEvent)="backBtn($event)" (navigationNextEvent)="nextBtn($event)">
                                    </app-creative-performance-stats-v7>
                                </div>
                                <div class="performance-graph-area" [ngClass]="{'performance-graph-area-2': creativeData.isSocial}">
                                    <app-creative-performance-graph-v7 [sectiontitle]="sectiontitle" 
                                        [legendData]="legend" [graphData]="creativeData.graphData[i]"
                                        [name]="'creative_' + creativeData.versionId"
                                        (legendSelected)="processSelectedLegendItem($event)"
                                        (mouseOutChart)="chartHover($event)" [markerEnabled]="true"
                                        (mouseOverChart)="chartHover($event)">
                                    </app-creative-performance-graph-v7>
                                </div>
                            </div>
                        </ngu-tile>
                        <span NguCarouselPrev class="leftRs" *ngIf="sectiontitle" (click)="resetLengends()"
                            [ngClass]="{'leftRs2': (sectiontitle && (sectiontitle !== 'Display')),
                            'leftRs3': (sectiontitle && (sectiontitle === 'Social'))}">
                        </span>
                        <span NguCarouselNext class="rightRs" *ngIf="sectiontitle" (click)="resetLengends()"
                            [ngClass]="{'rightRs2': (sectiontitle && (sectiontitle !== 'Display')),
                            'rightRs3': (sectiontitle && (sectiontitle === 'Social'))}">
                        </span>
                    </ngu-carousel>
                </div>
            </div>
        </div>
    </div>
</div>
<app-modal id="creative-preview-v1_{{key}}">
    <app-creative-ad-preview [creative]="selectedCreative"
        (modalClose)="closeCreativePreview('creative-preview-v1_' + key)"></app-creative-ad-preview>
    <div class="modal-background"></div>
</app-modal>